// extracted by mini-css-extract-plugin
export default {"logoHeader":"header_logoHeader__2jHRz"};